import { Button, MenuItem, TextField } from "@material-ui/core";
import { useHistory } from "react-router";
import { useEffect, useState } from "react";
import { useGetQuizzes } from "../../hooks/useGetQuizzes";
import "./AdminAction.css";
import { useGetUser } from "../../hooks/useGetUser";
import QuizResult from "../../components/QuizResults/QuizResults";
import { useGetSections } from "../../hooks/useGetSections";
import axios from "axios";

const AdminAction = () => {
  const { user } = useGetUser();
  const history = useHistory();
  const [toggleQuiz, setToggleQuiz] = useState(false);
  const [toggleQuizResult, setToggleQuizResult] = useState(false);
  const [quizNames, setQuizNames] = useState([]);
  const [sections, setSections] = useState();
  const [section, setSection] = useState(undefined);
  const [quiz, setQuiz] = useState('');
  const { quizzes } = useGetQuizzes();
  const { sectionData } = useGetSections();

  const createQuiz = async () => {
    history.push("/admin-quiz");
  };

  localStorage.setItem('user', user);

  const toggleManageQuiz = async () => {
    setToggleQuizResult(false);
    setQuiz("");
    if (toggleQuiz) {
      setToggleQuiz(false);
      setQuiz('');
    } else {
      setToggleQuiz(true);
    }
  };

  const toggelQuizResult = async () => {
    setToggleQuiz(false);
    setSection("");
    if (toggleQuizResult) {
      setToggleQuizResult(false);
      setQuiz('');
    } else {
      setToggleQuizResult(true);
    }
  };

  const logout = async () => {
    localStorage.clear();
    history.push("/admin-login");
  };

  const download = async () => {
    const sectionName = sections.find(sec => sec._id === section);
    const quizName = quizzes.find(q => q._id === quiz);

    try {
      const { data } = await axios.post(`https://computer-quiz-backend.herokuapp.com/quizzes/${quiz}/results/export?year_section=${section}`,
      {},
      {
        headers: { 'api-token': localStorage.getItem('token') }
      });
      const blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      if (navigator.msSaveBlob) { // In case of IE 10+
        navigator.msSaveBlob(blob, `${sectionName.year_section} - ${quizName.quiz_name}.csv`);
      } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
          // Browsers that support HTML5 download attribute
          const url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          link.setAttribute('download', `${sectionName.year_section} - ${quizName.quiz_name}.csv`);
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleQuizSelection = async (id) => {
    history.push("/admin-quiz/" + id)
  };

  const handleQuizResult = async (id) => {
    setQuiz(id);
  };

  useEffect(() => {
    setSections(sectionData);
  }, [sectionData]);

  const handleSetSection = async (id) => {
    setSection(id);
    try {
      const { data } = await axios.get(`https://computer-quiz-backend.herokuapp.com/quizzes/list?year_section=${id}`);
      setQuizNames(data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="content">
      <div className="settings">
        <span style={{ fontSize: 30 }}>Choose your action</span>
        <div className="settings__select">
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={createQuiz}
            style={{ marginBottom: '20px' }}
          >
            Create a Quiz
          </Button>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={toggleManageQuiz}
            style={{ marginBottom: '20px' }}
          >
            Manage quizzes
          </Button>
          {
            toggleQuiz && quizzes &&
            <TextField
              select
              label="Select Quiz" 
              value={quiz}
              onChange={(e) => handleQuizSelection(e?.target?.value)}
              variant="outlined"
              style={{ marginBottom: 30 }}
            >
              {quizzes.map((cat) => (
                <MenuItem
                  key={cat._id}
                  value={cat._id}
                >
                  {cat.quiz_name}
                </MenuItem>
              ))}
            </TextField>
          }
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={toggelQuizResult}
            style={{ marginBottom: '20px' }}
          >
            View Quiz Results
          </Button>
          { toggleQuizResult && sections &&
            <TextField
              select
              label="Select Section"
              value={section}
              onChange={(e) => handleSetSection(e?.target?.value)}
              variant="outlined"
              style={{ marginBottom: 30 }}
            >
              {sections.map((cat) => (
                <MenuItem
                  key={cat.year_section}
                  value={cat._id}
                >
                  {cat.year_section}
                </MenuItem>
              ))}
            </TextField>
          }
          {
            toggleQuizResult && section &&
            <TextField
              select
              label="Select Quiz" 
              value={quiz}
              onChange={(e) => handleQuizResult(e?.target?.value)}
              variant="outlined"
              style={{ marginBottom: 30 }}
            >
              { quizNames.length && quizNames.map((cat) => (
                <MenuItem
                  key={cat._id}
                  value={cat._id}
                >
                  {cat.quiz_name}
                </MenuItem>
              ))}
            </TextField>
          }
          {
            toggleQuizResult && section && quiz &&
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={download}
              style={{ marginTop: '-10px' }}
            >
              Download This Quiz Result
            </Button>
          }
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={logout}
            style={{ marginTop: '30px' }}
          >
            Logout
          </Button>
        </div>
      </div>
      {
        toggleQuizResult && quiz && 
        <div className="settings">
          <QuizResult
            quiz={quiz}
            section={section}/>
        </div>
      }
    </div>
  );
};

export default AdminAction;
